webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "2ubv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__("Ue/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition__ = __webpack_require__("TAxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import { CSSTransitionGroup } from 'react-transition-group'

// import { CSSTransition } from 'react-transition-group'



var duration = 500;

var headerDivDefaultStyle = {
  width: '100%',
  // display: 'flex',
  // flexGrow: 1,
  // alignSelf: 'center',
  // transition: `font-size ${duration}ms ease-in-out, transform ${duration} ease-in-out`,
  transition: duration + 'ms ease-in-out',
  fontSize: '6vh',
  transform: 'translateX(0%)'
};

var headerDivTransitionStyles = {
  exiting: { fontSize: '6vh', transform: 'translateX(0%)' },
  exited: { fontSize: '2vh', transform: 'translateX(-50%)' }
};

var headerDefaultStyle = {
  position: 'relative',
  left: '0vh',
  transition: 'left ' + duration + 'ms ease-in-out'
};

var headerTransitionStyles = {
  exiting: { left: '0vh' },
  exited: { left: '14vh' }
};

var spacerDefaultStyle = {
  // transition: `flex-grow ${duration} ease-in-out`,
  // flexGrow: 1
  transition: 'transform ' + duration + ' ease-in-out',
  transform: 'translateX(50%)'
};

var spacerTransitionStyles = {
  exiting: { transform: 'translateX(50%)' },
  exited: { transform: 'translateX(0%)' }
};

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Header.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], {
      path: '/',
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition___default.a,
          {
            'in': props.match.isExact,
            timeout: 0
          },
          function (state) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              {
                className: 'App-heading'
              },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                {
                  style: _extends({}, headerDivDefaultStyle, headerDivTransitionStyles[state])
                },
                __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],
                  { to: '/' },
                  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                    'h2',
                    {
                      style: _extends({}, headerDefaultStyle, headerTransitionStyles[state])
                    },
                    'Brainy.Space'
                  )
                )
              )
            );
          }
        );
      }
    });
  };

  return Header;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "Q8JH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ue/Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zi+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FactsGrid_css__ = __webpack_require__("Q8JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FactsGrid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FactsGrid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var footerStyle = {
  gridColumnStart: 2,
  gridColumnEnd: 'end'
};

var preFlipDelay = 2500;
var postFlipDelay = 1000;
var flipInterval = 100;
var postGameDelay = 1000;

var emojis = ['😎', '🤩', '🤓', '🤖', '👽', '👾', '😺', '👍', '🐶', '🐱', '🐨', '🐸', '🐷', '🐵', '🐧', '🍀', '🥇', '🏆', '🏅', '🎨', '🎧', '🎉', '🎈', '🕶', '🐞', '🦄', '🦋', '🐛', '🦕', '🦖', '🐬', '🐳', '🐉', '🦒', '💐', '🌸', '🌻', '🌈', '🌛', '🍎', '🥑', '🍌', '🍕', '🍭', '🍰', '🍪', '🍩', '🍫', '⚽️', '🏀', '🏈', '⚾️', '🎾', '🏐', '🏉', '🏒', '🥁', '🎮', '🏵', '🎸', '🚀', '🏰', '🛸', '🌋'];
var randomEmoji = function randomEmoji() {
  return emojis[parseInt(Math.random() * emojis.length)];
};

var op = function op(subject, a, b) {
  return subject == 'add' ? a + b : a * b;
};

var _ref = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
  'div',
  { className: 'grid-footer', style: footerStyle },
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    'span',
    null,
    'Get Ready...'
  )
);

var FactsGrid = function (_Component) {
  _inherits(FactsGrid, _Component);

  function FactsGrid(props) {
    _classCallCheck(this, FactsGrid);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      flipCount: 0,
      started: false,
      done: false,
      current: null,
      input: '',
      activeRow: 0,
      activeCol: 0,
      lockCol: 0,
      lockRow: 0,
      wrongRow: 0,
      wrongCol: 0,
      prevRow: 0,
      prevCol: 0,
      grid: _this.initialGrid()
    };
    return _this;
  }

  FactsGrid.prototype.initialGrid = function initialGrid() {
    var _this2 = this;

    var r = __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Range(1, this.props.size + 1);

    return r.reduce(function (m, y) {
      return m.set(y, r.reduce(function (m2, x) {
        return m2.set(x, __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.fromJS({
          x: x, y: y,
          answer: op(_this2.props.subject, x, y),
          done: false
        }));
      }, __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map({})));
    }, __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map({}));
  };

  FactsGrid.prototype.componentDidMount = function componentDidMount() {
    this.pregame();
  };

  FactsGrid.prototype.pregame = function pregame() {
    var _this3 = this;

    setTimeout(function () {
      _this3.interval = setInterval(function () {
        _this3.setState({ flipCount: _this3.state.flipCount + 1 });
        // console.log('flipCount', this.state.flipCount)
        if (_this3.state.flipCount > 2 * _this3.props.size + 1) {
          clearInterval(_this3.interval);
          setTimeout(function () {
            _this3.startGame();
          }, postFlipDelay);
        }
      }, flipInterval);
    }, preFlipDelay);
  };

  FactsGrid.prototype.postgame = function postgame() {
    var _this4 = this;

    this.setState({
      activeRow: 0,
      activeCol: 0,
      lockCol: 0,
      lockRow: 0,
      wrongRow: 0,
      wrongCol: 0,
      done: true
    });
    setTimeout(function () {
      _this4.interval = setInterval(function () {
        _this4.setState({
          flipCount: _this4.state.flipCount - 1
        });
        if (_this4.state.flipCount < 100000) {
          _this4.setState({
            flipCount: 0
          });
        }
      }, 500);
    }, postGameDelay);
  };

  FactsGrid.prototype.startGame = function startGame() {
    this.setState({
      started: true
    });
    this.showNext();

    gtag('event', 'start-game');
  };

  FactsGrid.prototype.setActive = function setActive(r, c) {
    var s = {
      activeRow: r,
      activeCol: c,
      input: ''
    };
    if (this.state.activeRow || this.state.activeCol) {
      s.prevRow = this.state.activeRow, s.prevCol = this.state.activeCol;
    }

    this.setState(s);

    if (this.input) {
      this.input.focus();
    }
  };

  FactsGrid.prototype.lockRowCol = function lockRowCol(r, c) {
    var _this5 = this;

    if (this.state.lockRow && this.state.lockRow == r || this.state.lockCol && this.state.lockCol == c) {
      this.setState({
        lockRow: 0,
        lockCol: 0
      });
    } else {
      this.setState({
        lockRow: r,
        lockCol: c
      });

      // Reset row/col if already finished
      if (r || c) {
        var allDoneRowCol = this.state.grid.reduce(function (list, gridRow) {
          return list.concat(gridRow);
        }, __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List([])).filter(function (cell) {
          return r && cell.get('y') == r || c && cell.get('x') == c;
        }).every(function (cell) {
          return cell.get('done');
        });

        if (allDoneRowCol) {
          this.setState({
            grid: this.state.grid.map(function (row, x_1) {
              return row.map(function (cell, y_1) {
                if (r && r == x_1 || c && c == y_1) {
                  return cell.set('done', false);
                }
                return cell;
              });
            })
          });
          gtag('event', 'complete-row-column', {
            op: this.props.subject,
            size: this.props.size,
            row: r,
            col: c
          });
        } else {
          gtag('event', 'lock-row-column', {
            op: this.props.subject,
            size: this.props.size,
            row: r,
            col: c
          });
        }
      }
    }
    setTimeout(function () {
      _this5.showNext();
    }, 10);
  };

  FactsGrid.prototype.showNext = function showNext() {
    var _this6 = this;

    // let allCards =
    // console.log('grid:')
    // console.log(this.state.grid.toJS())
    var _state = this.state,
        prevRow = _state.prevRow,
        prevCol = _state.prevCol;
    // console.log('showNext', this.state.activeRow, this.state.activeCol, this.state.prevRow, this.state.prevCol)

    var flatListRemaining = this.state.grid.reduce(function (list, gridRow) {
      return list.concat(gridRow);
    }, __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.List([])).filter(function (c) {
      return !c.get('done');
    }).filter(function (c) {
      if (_this6.state.lockRow) {
        return c.get('y') == _this6.state.lockRow;
      } else if (_this6.state.lockCol) {
        return c.get('x') == _this6.state.lockCol;
      }
      return true;
    }).sortBy(function (c) {
      return c.get('x') + c.get('y') + (c.get('x') == prevCol && c.get('y') == prevRow ? 100 : 0);
    });
    // TODO: have sort avoid recent flips
    // console.log(flatListRemaining.map(c => `${c.get('y')},${c.get('x')}`).join('__'))

    var done = false;

    if (flatListRemaining.size) {
      var frs = flatListRemaining.size;
      // Choose from the lower numbers (at least early on)...
      // Always avoid the previous one if possible...
      // Account for locked row/col
      var s = this.state.lockRow || this.state.lockCol ? this.props.size : this.props.size * this.props.size;
      var slice = frs < s / 2 ? s : Math.floor(s / 2);

      slice = Math.max(1, Math.min(slice, frs));

      if (slice > 1 && (this.state.wrongCol || this.state.wrongRow)) {
        // console.log('dec slice', slice)
        slice--;
      }

      var ix = parseInt(Math.random() * slice);
      var n = flatListRemaining.get(ix);
      if (!n) {
        console.error('something went wrong');
      }
      var next = n.toJS();
      this.setActive(next.y, next.x);
    } else if (this.state.lockRow || this.state.lockCol) {
      this.lockRowCol(0, 0);
      return;
    } else {
      gtag('event', 'finish-game', {
        op: this.props.subject,
        size: this.props.size
      });
      this.postgame();
    }
  };

  FactsGrid.prototype.submit = function submit() {
    var _this7 = this;

    var r = this.state.activeRow;
    var c = this.state.activeCol;
    var active = this.state.activeRow && this.state.activeCol && this.state.grid.getIn([r, c]);

    if (!active) {
      return;
    }

    var answer = active && active.get('answer');

    if (parseInt(this.input.value) == answer) {
      // console.log('✅', answer)

      this.setState({
        activeRow: 0,
        activeCol: 0,
        prevRow: r,
        prevCol: c,
        input: '',
        grid: this.state.grid.setIn([r, c, 'done'], true),
        wrongCol: 0,
        wrongRow: 0
      });
    } else {
      // console.log(`❌ [${this.input.value}] !== [${answer}]`,)
      this.setState({
        activeRow: 0,
        activeCol: 0,
        prevRow: r,
        prevCol: c,
        input: '',
        wrongRow: r,
        wrongCol: c
      });
    }
    setTimeout(function () {
      _this7.showNext();
    }, 10);
  };

  FactsGrid.prototype.reset = function reset() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.setState({
      done: false,
      started: false,
      grid: this.initialGrid()
    });
    this.pregame();
  };

  FactsGrid.prototype.changeInput = function changeInput(ev) {
    this.setState({
      input: ev.target.value
    });
  };

  FactsGrid.prototype.renderCell = function renderCell(r, c, ix) {
    var _this8 = this;

    var allDone = this.state.done;
    var active = !allDone && this.state.activeRow == r && this.state.activeCol == c;
    var done = this.state.grid.getIn([r, c, 'done']);
    var wrong = this.state.wrongRow == r && this.state.wrongCol == c;
    var flipped = !wrong && (active || r + c <= this.state.flipCount && !done || r + c >= this.state.flipCount && allDone);

    var notLocked = this.state.lockRow && r !== this.state.lockRow || this.state.lockCol && c !== this.state.lockCol;

    var back = this.state.done ? randomEmoji() : '?';

    // const flipped = this.state.grid.getIn([r * this.props.size + c, 'done'], false)
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        key: ix,
        className: 'grid-cell card' + (flipped ? ' flipped' : '') + (active ? ' active' : '') + (done ? ' done' : '') + (notLocked ? ' notLocked' : '') + (wrong ? ' wrong' : ''),
        onClick: function onClick() {
          return _this8.setActive(r, c);
        }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'figure',
        { className: 'front' },
        op(this.props.subject, r, c)
      ),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'figure',
        { className: 'back' },
        back
      )
    );
  };

  FactsGrid.prototype.renderFooter = function renderFooter() {
    var _this9 = this;

    var inputValue = this.state.input;
    var opSymbol = this.props.subject == 'add' ? '+' : '×';

    if (!this.state.started) {
      return _ref;
    } else if (this.state.done) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: 'grid-footer', style: footerStyle },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          { className: 'button', onClick: this.reset.bind(this) },
          'Again ?'
        )
      );
    } else {
      var r = this.state.activeRow;
      var c = this.state.activeCol;
      var active = this.state.activeRow && this.state.activeCol && this.state.grid.getIn([r, c]);
      var placeholder = active && active.get('y') + ' ' + opSymbol + ' ' + active.get('x') || '';
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        {
          className: 'grid-footer',
          style: footerStyle
        },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'form',
          { onSubmit: function onSubmit(ev) {
              ev.preventDefault();
              ev.stopPropagation();
              _this9.submit();
            } },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
            key: 'inputKey'
            // type="tel" pattern="[0-9]*" novalidate
            , placeholder: placeholder,
            ref: function ref(_ref3) {
              return _this9.input = _ref3;
            },
            type: 'number',
            value: inputValue,
            onChange: this.changeInput.bind(this),
            onKeyUp: function onKeyUp(_ref2) {
              // console.log('key', which);
              // (which == 13) && this.submit()

              var which = _ref2.which;
            }
          })
        )
      );
    }
  };

  FactsGrid.prototype.render = function render() {
    var _this10 = this;

    var size = this.props.size;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: 'App-main facts-grid' + (this.state.done ? ' finished' : '')
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        {
          className: 'grid',
          style: {
            gridTemplateColumns: Array(size + 1).fill('1fr').join(' ') + ' [end]',
            gridTemplateRows: Array(size + 1).fill('1fr').join(' ') + ' 2fr'
          }
        },
        __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Range(0, (size + 1) * (size + 1)).map(function (n, ix) {
          // +1's above are for header row and column (not Range off-by-one)
          var r = parseInt(n / (size + 1)) || 0;
          var c = n % (size + 1);
          if (!r && !c) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { key: ix });
          } else if (!r) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              {
                key: ix,
                className: 'grid-header',
                onClick: function onClick() {
                  _this10.lockRowCol(r, c);
                }
              },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'span',
                null,
                c
              )
            );
          } else if (!c) {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              {
                key: ix,
                className: 'grid-header',
                onClick: function onClick() {
                  _this10.lockRowCol(r, c);
                }
              },
              __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'span',
                null,
                r
              )
            );
          } else {
            return _this10.renderCell(r, c, ix);
          }
        }),
        this.renderFooter()
      )
    );
  };

  return FactsGrid;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FactsGrid);

/***/ }),

/***/ "cilB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lJKH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__("Ue/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__("UVf0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
  'div',
  { className: 'App-main App-flex-row main-buttons' },
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],
    { className: 'subject-link', to: '/FlashCards/math/Add/10' },
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      null,
      'Addition 10x10'
    )
  ),
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],
    { to: '/FlashCards/math/Mult/10', className: 'subject-link' },
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      null,
      'Multiplication 10x10'
    )
  ),
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],
    { to: '/FlashCards/math/Mult/12', className: 'subject-link' },
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      null,
      'Multiplication 12x12'
    )
  )
);

var Main = function (_Component) {
  _inherits(Main, _Component);

  function Main() {
    _classCallCheck(this, Main);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Main.prototype.render = function render() {
    return _ref;
  };

  return Main;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Main);

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__("cilB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("pnOm");







Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */], null), document.querySelector('#app'));

/***/ }),

/***/ "pnOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition__ = __webpack_require__("TAxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css__ = __webpack_require__("Ue/Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Main__ = __webpack_require__("lJKH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__("2ubv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FactsGrid__ = __webpack_require__("Zi+Q");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var duration = 400;

var defaultStyle = {
  transition: 'opacity ' + duration + 'ms ease-in-out',
  opacity: 0,
  flexGrow: 1,
  display: 'flex'
};

var transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 }
};

var Fade = function Fade(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition___default.a,
    { 'in': props.in, timeout: props.timeout || 1000, appear: true, exit: true },
    function (state) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: _extends({}, defaultStyle, transitionStyles[state]) },
        props.children
      );
    }
  );
};

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/', component: __WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */] });

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Main__["a" /* default */], null);

var _ref5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FactsGrid__["a" /* default */], { subject: 'add', size: 10 });

var _ref7 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FactsGrid__["a" /* default */], { subject: 'mult', size: 10 });

var _ref9 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FactsGrid__["a" /* default */], { subject: 'mult', size: 12 });

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  App.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'App' },
        _ref,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/', exact: true, render: function render(_ref2) {
            var match = _ref2.match;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              { 'in': match.isExact, timeout: 300 },
              _ref3
            );
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/FlashCards/math/Add/10', render: function render(_ref4) {
            var match = _ref4.match;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              { 'in': match.isExact },
              _ref5
            );
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/FlashCards/math/Mult/10', render: function render(_ref6) {
            var match = _ref6.match;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              { 'in': match.isExact },
              _ref7
            );
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */], { path: '/FlashCards/math/Mult/12', render: function render(_ref8) {
            var match = _ref8.match;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              { 'in': match.isExact },
              _ref9
            );
          } })
      )
    );
  };

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.58ce4496.js